// store/feedbackSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  closeTime: 3000,
  open: false,
  content: null,
  type: 'loader', // info, error, success, etc.
  redirectURL: null
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    showFeedback: (state, action) => {
      state.open = true;
      state.content = action.payload.content;
      state.type = action.payload.type || 'info';
      state.closeTime = action.payload.closeTime || 3000;
      state.redirectURL = action.payload.redirectURL;
    },
    hideFeedback: (state) => {
      state.open = false;
      state.content = null;
      state.type = 'info';
      state.closeTime = 3000;
      state.redirectURL = null;
    }
  }
});

export const { showFeedback, hideFeedback } = feedbackSlice.actions;
export default feedbackSlice.reducer;
